/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaCardHeader/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function TysiaCardHeader({
  children,
  viewPath = "/DesignSystem/TysiaCard/TysiaCardHeader",
  justifyContent = "space-between",
  backgroundColor,
  paddingTop,
  paddingRight,
  paddingLeft,
  paddingBottom,
  borderTopLeftRadius,
  borderTopRightRadius,
  borderBottomWidth = 0,
  borderBottomStyle = "solid",
  borderBottomColor
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let paddingTopOrdtSpaceS = paddingTop ?? dtSpaceS
let paddingRightOrdtSpaceM = paddingRight ?? dtSpaceM
let paddingLeftOrdtSpaceM = paddingLeft ?? dtSpaceM
let borderBottomColorOrdtColorsNeutral200 = borderBottomColor ?? dtColorsNeutral200
  return (<React.Fragment
>
<div
  data-testid="TysiaCardHeader.Horizontal"
  data-view-path={viewPath}
 style={{'--jc-1-2w541f': justifyContent,'--bc-2-2w541f': backgroundColor,'--pt-3-2w541f': typeof paddingTopOrdtSpaceS === 'number' ? `${paddingTopOrdtSpaceS}px` : paddingTopOrdtSpaceS,'--pr-4-2w541f': typeof paddingRightOrdtSpaceM === 'number' ? `${paddingRightOrdtSpaceM}px` : paddingRightOrdtSpaceM,'--pl-5-2w541f': typeof paddingLeftOrdtSpaceM === 'number' ? `${paddingLeftOrdtSpaceM}px` : paddingLeftOrdtSpaceM,'--pb-6-2w541f': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--btlr-7-2w541f': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-8-2w541f': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--bbw-9-2w541f': typeof borderBottomWidth === 'number' ? `${borderBottomWidth}px` : borderBottomWidth,'--bbs-10-2w541f': borderBottomStyle,'--bbc-11-2w541f': borderBottomColorOrdtColorsNeutral200}}
 className={`views-block ${styles.Horizontal}`}
>
<Children
  viewPath={`${viewPath}/Children`}
>
{children}
</Children>
</div>
</React.Fragment>)
}